import { all } from 'redux-saga/effects';
import getBaseRequest from './base-request';

export const overviewSaga = function* root() {
  yield all([getBaseRequest()]);
};
